<template>
  <div class="home xlbox" :style="{ height: pageHeight-56 + 'px' }">
    <van-dropdown-menu active-color="#353535">
      <van-dropdown-item :title="title" ref="item">
        <van-cell
          center
          v-for="(item, index) in list"
          :key="index"
          :title="item.elepoId+'('+item.mlName+')'"
          @click="onConfirm(item)"
          :title-style="item.elepoId == searchId&&item.mlName== mlNamec ? 'color:#1989fa' : ''"
        >
          <template #right-icon>
            <!-- 1：架空型 2:电缆型 3:开关型 -->
            <van-icon :name="item.type==1?src1 : item.type==2?src2: item.type==3?src3:''" />
            <span>（{{ item.type==1?'架空' : item.type==2?'电缆': item.type==3?'行波模块':'' }}）</span>

          </template>
        </van-cell>
        <!-- <van-cell center title="包邮">
          <template #right-icon>
            <van-icon name="https://b.yzcdn.cn/vant/icon-demo-1126.png" />
          </template>
        </van-cell>
        <van-cell center title="团购">
          <template #right-icon>
            <van-icon name="https://b.yzcdn.cn/vant/icon-demo-1126.png" />
          </template>
        </van-cell> -->
      </van-dropdown-item>
    </van-dropdown-menu>
    <div class="tj historyDiares faultDiares" :style="{ height: pageHeight-84 + 'px' }">
      <div style="height: auto; margin-bottom: 8px">
        <van-image width="100%" height="100%" fit="contain" :src="xlsrcImg" >
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
      </div>
      <van-cell-group>
        <van-cell title="线路名称:" :value="workInfoLogSSFHZCVO.mlName? workInfoLogSSFHZCVO.mlName:'/'" />
        <van-cell title="线路杆塔" :value="workInfoLogSSFHZCVO.elepoId? workInfoLogSSFHZCVO.elepoId:'/'" />
        <van-cell title="检测时间" :value="workInfoLogSSFHZCVO.gpsTime? workInfoLogSSFHZCVO.gpsTime:'/'" />
        <van-cell title="A相电流" :value="workInfoLogSSFHZCVO.loadCurA? workInfoLogSSFHZCVO.loadCurA:'/'" />
        <van-cell title="B相电流" :value="workInfoLogSSFHZCVO.loadCurB? workInfoLogSSFHZCVO.loadCurB:'/'" />
        <van-cell title="C相电流" :value="workInfoLogSSFHZCVO.loadCurC? workInfoLogSSFHZCVO.loadCurC:'/'" />
        <van-cell title="A相电压" :value="workInfoLogSSFHZCVO.bavolA&&isType!==1? workInfoLogSSFHZCVO.bavolA:'/'" />
        <van-cell title="B相电压" :value="workInfoLogSSFHZCVO.bavolB&&isType!==1? workInfoLogSSFHZCVO.bavolB:'/'" />
        <van-cell title="C相电压" :value="workInfoLogSSFHZCVO.bavolC&&isType!==1? workInfoLogSSFHZCVO.bavolC:'/'" />
        <van-cell title="零序电压" :value="workInfoLogSSFHZCVO.bavol0&&isType!==1? workInfoLogSSFHZCVO.bavol0:'/'" />
        <van-cell title="零序电流" :value="workInfoLogSSFHZCVO.loadCur0? workInfoLogSSFHZCVO.loadCur0:'/'" />
        <van-cell title="电池电压" :value="workInfoLogSSFHZCVO.bavol? workInfoLogSSFHZCVO.bavol:'/'" />
        <van-cell title="开关状态" :value="workInfoLogSSFHZCVO.kgType==1?'合' : workInfoLogSSFHZCVO.kgType==2?'分': workInfoLogSSFHZCVO.kgType==3?'异常':'/'" />
        <!-- <van-cell title="开关状态" :value="workInfoLogSSFHZCVO.kgType==1?'合':''" /> -->
      </van-cell-group>
      <!-- <div style="position:fixed;left:0;bottom:0;z-index:1;"> -->
        <van-button
          :loading="isLoading"
          type="info"
          block
          loading-text="实时负荷召测"
          @click="getSSFHZCCX"
          >实时负荷召测</van-button
        >
      <!-- </div> -->
    </div>
    <ul class="fhitem">
            <li @click="getBHDZ" v-show="kgshow&&list.length>0">
              <div>
                <img src="../assets/bhdz@3x.png" alt="" />
                <p>保护定值</p>
              </div>
            </li>
            <li @click="getFHQX" v-show='sbtypeshow&&list.length>0'>
              <div>
                <img src="../assets/fhqx@3x.png" alt="" />
                <p>负荷曲线</p>
              </div>
            </li>
            <li @click="getSOE" v-show="kgshow&&list.length>0">
              <div>
                <img src="../assets/soe@3x.png" alt="" />
                <p>SEO查询</p>
              </div>
            </li>
            <li @click="getFHList" v-show='sbtypeshow&&list.length>0'>
              <div>
                <img src="../assets/fhlb@3x.png" alt="" />
                <p>负荷列表</p>
              </div>
            </li>
            <li @click="getXSJL" v-show="kgshow&&list.length>0">
              <div>
                <img src="../assets/xsjl@3x.png" alt="" />
                <p>线损计量</p>
              </div>
            </li>
          </ul>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Col,
  Row,
  Cell,
  CellGroup,
  Button,
  Icon,
  NavBar,
  List,
  PullRefresh,
  DropdownMenu,
  DropdownItem,
  Image as VanImage, Loading
} from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(
  Col,
  Row,
  Cell,
  CellGroup,
  Button,
  Icon,
  NavBar,
  List,
  PullRefresh,
  DropdownMenu,
  DropdownItem,
  VanImage, Loading
)

export default {
  name: 'faultDetialsPage',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [VanImage.name]: VanImage,
    [Loading.name]: Loading
  },
  data () {
    return {
      isType:'',//为1的话A相电压，B相电压，C相电压，零序电压斜杠显示
      sbtypeshow:false,
      kgshow: false,
      count: 0,
      timer: null, // 定时器名称
      isLoading: false,
      loading: false,
      finished: false,
      pageHeight: window.innerHeight - 46,
      title: '设备选择：',
      searchId: '',
      mlNamec: '',
      mlineId: '', // 线路id
      netMlineId: '', // 复杂线路id
      type: 1, // 1：架空型 2:电缆型 3:开关型
      workInfoLogSSFHZCVO: '', // 实时负荷召测返回信息
      src1: require('../assets/jk@3x.png'),
      src2: require('../assets/dl@3x.png'),
      src3: require('../assets/kg@3x.png'),
      // value1: 0,
      // option1: [
      //   { text: `设备选择: ${this.elepoId}`, value: 0 },
      //   { text: '新款商品', value: 1 },
      //   { text: '活动商品', value: 2 }
      // ]
      list: [{
        elepoId: '' // 默认杆塔id
      }

      ],
      first1: true// 区分是否第一次进入页面
    }
  },
  created () {},
  watch: {
    "$route.path": function (newVal, oldVal) {
      //console.log(newVal + "---" + oldVal);
      if (
        (oldVal === "/faultDetialsPage")
      ) {
        clearInterval(this.timer)// 清除定时器
        this.timer = null
      }
    },
  },
  mounted () {
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.netMlineId=this.$route.query.mlineId
    // this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.getElePo()// 设备选择下拉框接口

    // 10分钟刷1次这个接口,退出该页面后清除定时器
    this.timer = setInterval(() => {
      this.getSSFHZC()// 实时负荷召测接口
    }, 600000)// 隔10分钟刷一次600000
  },
 
  beforeDestroy () {    
    clearInterval(this.timer)// 清除定时器
    this.timer = null
  },
  methods: {
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1) // 返回上一页面
    },
    onConfirm (item) {
      this.searchId = item.elepoId
      this.mlNamec = item.mlName
      // console.log(item.mlName)
      this.title = '设备选择：' + item.elepoId + '(' + item.mlName + ')' + '(' + (item.type === 1 ? '架空' : item.type === 2 ? '电缆' : item.type === 3 ? '行波模块' : '') + ')'
      this.$refs.item.toggle()
      this.first1 = false
      this.mlineId = item.mlineId
      this.getSSFHZC()// 实时负荷召测接口
    },
    getElePo () {
      this.list = []
      this.util.post('/getElePo', {
        mlineId: this.mlineId
      }).then(({ data }) => {
        if (data.code === 200) {
          this.list = data.data.list
          // console.log(this.list)
          this.list.forEach((item, index) => {
            // 默认选中第1个
            if (index === 0) {
              this.searchId = item.elepoId
              this.mlNamec = item.mlName
              // console.log('this.searchId' + this.searchId + 'item.elepoId' + item.elepoId)
              localStorage.setItem('paramElepoId', item.elepoId) // 存储杆塔id
              // + '(' + item.type === 1 ? '架空' : item.type === 2 ? '电缆' : item.type === 3 ? '开关' : '' + ')'
              this.title = '设备选择：' + item.elepoId + '(' + item.mlName + ')' + '(' + (item.type === 1 ? '架空' : item.type === 2 ? '电缆' : item.type === 3 ? '行波模块' : '') + ')'
              this.mlineId = item.mlineId
              // console.log(this.mlineId)
              this.getSSFHZC()// 实时负荷召测接口
            }
          })
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getSSFHZC () {
      let param = {}
      param.mlineId = this.mlineId
      param.netMlineId= this.netMlineId
      if (this.first1) {
        // 默认进来
        param.elepoId = localStorage.getItem('paramElepoId')
        localStorage.setItem('paramElepoId', param.elepoId) // 存储杆塔id
        // console.log(this.type)
        // 如果非开关型（显示负荷曲线负荷列表），开关型（显示所有）
        if (this.type === 3) {
          this.kgshow = true
        } else {
          this.kgshow = false
        }
      } else {
        // 选择后
        param.elepoId = this.searchId
        localStorage.setItem('paramElepoId', this.searchId) // 存储杆塔id
        // console.log(this.type)
        // 如果非开关型（显示负荷曲线负荷列表），开关型（显示所有）
        if (this.type === 3) {
          this.kgshow = true
        } else {
          this.kgshow = false
        }
      }

      this.util.post('/getSSFHZC', param).then(({ data }) => {
        if (data.code === 200) {
          this.sbtypeshow=true
          //console.log(data)
          this.isType=data.data.type
          this.workInfoLogSSFHZCVO = data.data.workInfoLogSSFHZCVO
        } else {
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    getSSFHZCCX () {
      if (this.mlineId && localStorage.getItem('paramElepoId')) {
        this.isLoading = true
        let param = {}
        param.mlineId = this.mlineId
        param.netMlineId = this.netMlineId
        if (this.first1) {
        // 默认进来
          // console.log(localStorage.getItem('paramElepoId'))
          param.elepoId = localStorage.getItem('paramElepoId')
          localStorage.setItem('paramElepoId', param.elepoId) // 存储杆塔id
          // param.elepoId = localStorage.getItem('paramElepoId')
          // localStorage.setItem('paramElepoId', param.elepoId) // 存储杆塔id
        } else {
        // 选择后
          // console.log(this.searchId)
          param.elepoId = this.searchId
          localStorage.setItem('paramElepoId', this.searchId)
          // param.elepoId = this.list[0].elepoId
          // localStorage.setItem('paramElepoId', this.list[0].elepoId) // 存储杆塔id
        }
        this.util.post('/getSSFHZCCX', param).then(({ data }) => {
          if (data.code === 200) {
            //console.log(data)
            this.isType=data.data.type
            this.workInfoLogSSFHZCVO = data.data.workInfoLogSSFHZCVO
            this.isLoading = false
          } else {
            return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
          }
        })
      } else {
        this.util.toast('数据没加载完成！')
      }
    },
    getBHDZ () {
      if (this.mlineId && localStorage.getItem('paramElepoId')) {
        this.$router.push({ path: '/BHDZPage', query: { mlineId: this.mlineId, elepoId: localStorage.getItem('paramElepoId') } })// 跳转到保护定值页面
      } else {
        this.util.toast('数据没加载完成！')
      }
    },
    getSOE () {
      if (this.mlineId && localStorage.getItem('paramElepoId')) {
        this.$router.push({ path: '/SOEPage', query: { mlineId: this.mlineId } })// 跳转到SOE页面
      } else {
        this.util.toast('数据没加载完成！')
      }
    },
    getFHQX () {
      if (this.mlineId && localStorage.getItem('paramElepoId')) {
        this.$router.push({ path: '/FHQXPage', query: { mlineId: this.mlineId, elepoId: localStorage.getItem('paramElepoId'),isType: this.isType } })// 跳转到负荷曲线页面
      } else {
        this.util.toast('数据没加载完成！')
      }
    },
    getFHList () {
      if (this.mlineId && localStorage.getItem('paramElepoId')) {
        this.$router.push({ path: '/FHListPage', query: { mlineId: this.mlineId, elepoId: localStorage.getItem('paramElepoId') } })// 跳转到负荷列表页面
      } else {
        this.util.toast('数据没加载完成！')
      }
    },
    getXSJL () {
      if (this.mlineId && localStorage.getItem('paramElepoId')) {
        this.$router.push({ path: '/XSJLPage', query: { mlineId: this.mlineId, elepoId: localStorage.getItem('paramElepoId') } })// 跳转到线损计量页面
      } else {
        this.util.toast('数据没加载完成！')
      }
    }
  },
  computed: {
    xlsrcImg () {
      let xlsrcImg = window.config.baseUrl+'/showMlineImg?mlineId=' + this.$route.query.mlineId
      return xlsrcImg
    }

  }
}
</script>

<style scoped lang="less">

/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
/deep/.van-dropdown-menu__bar {
  width: 100vw;
  height: 34px;
  position: fixed;
  left: 0;
  top: 56px;
  z-index: 2;
}
/deep/.van-dropdown-menu__item{
  justify-content: space-around;/* end */
  padding: 0 20px;
}
/deep/.van-button--block{
  margin-bottom: 10px;
}
.home {
  background: #fff;
  margin-top: 56px;
}
.tj{
  margin-top: 34px;
}
.van-cell-group .van-cell:nth-child(even) {
  background: #f9f9f9;
}
</style>
